<template>
  <div class="my_container">
    <div class="my_breadcrumb_box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ name: 'Community' }">社区生态</el-breadcrumb-item>
        <el-breadcrumb-item>视频列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="glag_all">
      <div class="title_top_hr">
        <p>
          <i></i>
          <span>视频列表</span>
          <span class="comment_btn" :class="navTop === '最新' ? 'act' : ''" @click="tabClick('time')">最新</span>
          <span class="comment_btn" :class="navTop === '最热' ? 'act' : ''" @click="tabClick('hot')">最热</span>
          <el-divider></el-divider>
        </p>
      </div>
      <none-view v-if="list.length === 0" :login="load.login" :loading="load.loading" :data="list" :text="load.text"></none-view>
      <div class="reception_live_list">
        <div v-for="item in list" :key="item.id" class="reception_live_item" @click="allJump(2, item.list_id, item.nav_id, 5)">
          <div class="reception_live_item_top">
            <img :src="item.img" alt="封面">
          </div>
          <div class="reception_live_item_bottom">
            <div class="reception_live_info">
              <p class="reception_live_title">{{item.title}}</p>
            </div>
            <div class="reception_live_list_item_other">
              <div class="reception_lately_other">
                <span><i class="font_i">{{item.hot}} </i>热度</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="list.length > 0" class="hr_page lf">
      <page-button :list = "list"
      :limit = "listPage.limit"
      @page = "page"
      ref="page"></page-button>
    </div>
  </div>
</template>

<script>
import none from '../Public/none.vue'
import page from '../Public/page.vue'
export default {
  components: {
    noneView: none,
    pageButton: page
  },
  data () {
    return {
      navTop: '最新', // 排序选择
      navId: '', // 板块id
      navName: '', // 板块名称
      load: {
        login: false,
        loading: true,
        text: '暂无最近直播内容',
        data: []
      },
      list: [],
      listPage: {
        limit: 20,
        page: 1,
        sort: 2 // 1热度 2时间
      }
    }
  },
  created () {
    this.getVideoList()
  },
  methods: {
    // 获取信息
    getVideoList () {
      const vueThat = this
      vueThat.listPage.nav_id = vueThat.navId
      vueThat.myApi.communityVideoList(vueThat.listPage).then((res) => {
        vueThat.load.loading = false
        if (res.data.code === 200) {
          vueThat.list.push(...res.data.data)
        }
      })
    },
    // 头部切换
    tabClick (type) {
      const vueThat = this
      vueThat.load.loading = true
      vueThat.list = []
      if (type === 'time') {
        vueThat.navTop = '最新'
        vueThat.listPage.sort = 2
      } else {
        vueThat.navTop = '最热'
        vueThat.listPage.sort = 1
      }
      vueThat.getVideoList()
    },
    jump (listId, navId, isDoing) {
      this.mycommon.detailJump(this, listId, navId, isDoing)
    },
    allJump (type, listId, navId, isDoing) {
      this.mycommon.allJump(this, type, listId, navId, isDoing)
    },
    // 加载更多
    page (num) {
      console.log(num)
      this.listPage.page = num
      this.getVideoList()
    }
  }
}
</script>

<style>
</style>
